import { createSelector } from "reselect";
import { MODULE_NAME } from './verify.constants'
import {  IState } from "./verify.types";

const selectState = (state: { [MODULE_NAME]: IState }): IState => state[MODULE_NAME]

export const getLoading = createSelector(selectState, (state: IState): boolean => state.loading)
